import { ToastContainer } from 'react-toastify';
import { useThemeMode } from 'flowbite-react';
import 'react-toastify/dist/ReactToastify.css';

// Toast container that follows the app's light/dark theme. react-toastify's
// `theme` prop is set from Flowbite's resolved theme (`computedMode` collapses
// 'auto' → 'light' | 'dark'), so toasts flip with the rest of the UI instead
// of being locked to the default light palette.
const ThemedToastContainer = () => {
  const { computedMode } = useThemeMode();
  const theme = computedMode === 'dark' ? 'dark' : 'light';

  return <ToastContainer theme={theme} />;
};

export default ThemedToastContainer;
